<template>
  <el-dialog
  :visible="visible"
  :fullscreen="true"
  :close-on-press-escape="false"
  :show-close="false"
  append-to-body
  center
  v-loading.fullscreen.lock="fullScreenLoading"
  @open="open">
  <span slot="title" class="dialog-header">
    <span  class="title" >Bienvenue</span>
  </span>
  <el-form class="formContainer">
    <p>Veuillez sélectionner un compte : </p>
    <el-card class="flex customer" v-for="c in customers" :key="c.id" shadow="hover" @click.native="select(c)" :body-style="{width:'100%'}">
      <div class="star align-vertical p-10 fs-22" style="float:left;">
        <el-tooltip v-if="c.type==0" content="Compte personnel" placement="top">
          <i class="mdi mdi-account-circle align-vertical-middle"></i>
        </el-tooltip>
        <el-tooltip v-if="c.type==1" content="Compte entreprise" placement="top">
          <i class="mdi mdi-city align-vertical-middle"></i>
        </el-tooltip>
      </div>
      <div class="info box grow flex p-5">
        <div class="box grow flex column justify-center p-10">
          <div class="fullname fs-18"><strong>{{c.name}}</strong></div>
        </div>
        <div class="overdue align-vertical p-10">
          <span class="align-vertical-middle">
            <i class="el-icon-arrow-right"></i>
          </span>
        </div>
      </div>
    </el-card>
  </el-form>
  </el-dialog>
</template>
<script>


export default {
  name: 'Customer-profile-selection',
	props: {
		customers : Array,
    visible : Boolean
	},
  data() {
    return {
      fullScreenLoading:true,
    };
  },components: {

  },
	methods: {
    select(customer){
      this.$emit('select', customer);
    },
    closeDialog(){

      this.$emit('close');
    },
    open(){

      this.fullScreenLoading=false;
    }
	},
	computed: {

	},
  created(){

  }
}
</script>
<style lang="scss" scoped>
@import '../assets/scss/_variables';

.el-card__body{
  width:100%;
}

.el-icon-arrow-right:hover{
  font-weight:bold;
}



.customer{
  margin: 10px 0;
  padding: 5px;
  box-sizing: border-box;
  cursor: pointer;
  transition: all .5s .25s;
  opacity:0.8;
}

.customer:hover{
  opacity:1;
}


.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-20px;
  padding-top:10px;
  border-top:1px solid #E4E7ED;
  z-index:100;
}

.el-input__inner{
  border:0px;
}
.title {
	font-size : 1.6em;
	font-weight:bold;

}


.formContainer{
    margin-left:25%;
    width:50%;
  }


@media (max-width: 1366px) {
  .formContainer{
      margin-left:20%;
      width:60%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:95%;
    }
}

</style>
